import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=70bde020"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=70bde020&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports